import $ from 'jquery'
import store from 'store2'

import preloadFont from '../../lib/preloadFont'

import * as model from './model/model'
import * as type from './type/type'

import topbar from './topbar/topbar'
import search from './search/search'
import player from './player/player'
import edit from './edit/edit'
import controls from './controls/controls'

import refreshData from './lib/refreshData'

import migrateUserMarkers from './lib/migrateUserMarkers'

export default function(){

  var o = window.app =
    {
      model: model,
      type: type,
      data: null,
      player: null,
      edit: null,
      video: null,
      loading: false,
      playing: false,
      colors: {
        red: '#FB4820',
        yellow: '#E4D628',
      },
    }

  $('<style type="text/css"></style>')
  .append('::-webkit-scrollbar { display: none; }')
  .append(`a {color: white;}`)
  .append(`a:hover {color: white;}`)
  .appendTo('head')

  o.sounds = {
    beep: new Audio('asset/omb_beep.mp3'),
  }
  o.sounds.beep.volume = 0.1
  o.sounds.beep.load()

  preloadFont(function(){
    refreshData(o,function(error){

      if(error){
        alert('error refreshing data')

      } else {

        o.store = store.namespace('omb')

        o.topbar = topbar(o)
        o.player = player(o)
        o.controls = controls(o)
        o.search = search(o)
        o.edit = edit(o)

        migrateUserMarkers(o)

        o.container =
          $('body')
          .empty()
          .css({
            backgroundColor: "#000",
            fontFamily: "Helvetica, sans-serif",
            textAlign: "left",
            fontSize: "14px",
          })
          .append([
            o.topbar,
            o.player,
            o.controls,
            o.search,
            o.edit,
          ])

      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/client/view/admin/admin.js